import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/index'),
    meta: {title: "首页", keepAlive: true}
  },
  {
    path: '/product/:class_id/:zi_id',
    name: 'product',
    component: () => import('@/views/product/index'),
    meta: {title: "产品中心", keepAlive: true}
  },
  {
    path: '/product_detail/:example_id',
    name: 'product_detail',
    component: () => import('@/views/product/product_detail'),
    meta: {title: "产品详情", keepAlive: true}
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('@/views/contact/index'),
    meta: {title: "联系我们", keepAlive: true},
    redirect: "/contact/contact",
    children: [
      {
        path: 'contact',
        name: 'contact2',
        component: () => import('@/views/contact/contact'),
        meta: {title: "联系方式", keepAlive: true}
      },
      {
        path: 'join',
        name: 'join',
        component: () => import('@/views/contact/join'),
        meta: {title: "我要代理", keepAlive: true}
      },
      {
        path: 'recruit',
        name: 'recruit',
        component: () => import('@/views/contact/recruit'),
        meta: {title: "招贤纳士", keepAlive: true}
      },
    ]
  },
  {
    path: '/brand',
    name: 'brand',
    component: () => import('@/views/brand/index'),
    meta: {title: "品牌中心", keepAlive: true},
    redirect: "/brand/introduce",
    children: [
      {
        path: 'introduce',
        name: 'introduce',
        component: () => import('@/views/brand/introduce'),
        meta: {title: "品牌故事", keepAlive: true}
      },
      {
        path: 'culture',
        name: 'culture',
        component: () => import('@/views/brand/culture'),
        meta: {title: "品牌文化", keepAlive: true}
      },
      {
        path: 'development',
        name: 'development',
        component: () => import('@/views/brand/development'),
        meta: {title: "发展历程", keepAlive: true}
      },
      {
        path: 'honor',
        name: 'honor',
        component: () => import('@/views/brand/honor'),
        meta: {title: "荣誉资质", keepAlive: true}
      },
      {
        path: 'layout',
        name: 'layout',
        component: () => import('@/views/brand/layout'),
        meta: {title: "全球布局", keepAlive: true}
      },
    ]
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('@/views/download/index'),
    meta: {title: "下载中心", keepAlive: true},
    redirect: "/download/prodcatalogue",
    children: [
      {
        path: 'prodcatalogue',
        name: 'prodcatalogue',
        component: () => import('@/views/download/prodcatalogue'),
        meta: {title: "产品目录", keepAlive: true}
      },
      {
        path: 'proddata',
        name: 'proddata',
        component: () => import('@/views/download/proddata'),
        meta: {title: "产品资料", keepAlive: true}
      },
      {
        path: 'prodvideo',
        name: 'prodvideo',
        component: () => import('@/views/download/prodvideo'),
        meta: {title: "产品视频", keepAlive: true}
      },
    ]
  },

  {
    path: '/news/:id',
    name: 'news',
    component: () => import('@/views/news/index'),
    meta: {title: "新闻中心", keepAlive: true}
  },
  {
    path: '/news_detail/:news_id',
    name: 'news_detail',
    component: () => import('@/views/news/news_detail'),
    meta: {title: "新闻详情", keepAlive: true}
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/user/index'),
    meta: {title: "用户中心", keepAlive: true},
    redirect: "/user/feedback",
    children: [
      {
        path: 'feedback',
        name: 'feedback',
        component: () => import('@/views/user/feedback'),
        meta: {title: "用户反馈", keepAlive: true}
      },
      {
        path: 'policy',
        name: 'policy',
        component: () => import('@/views/user/policy'),
        meta: {title: "维保政策", keepAlive: true}
      },
      {
        path: 'network',
        name: 'network',
        component: () => import('@/views/user/network'),
        meta: {title: "服务网点", keepAlive: true}
      },
      {
        path: 'find',
        name: 'find',
        component: () => import('@/views/user/find'),
        meta: {title: "如何找到我们", keepAlive: true}
      },
      {
        path: 'distinguish',
        name: 'distinguish',
        component: () => import('@/views/user/distinguish'),
        meta: {title: "如何识别皇冠工具", keepAlive: true}
      },
      {
        path: 'guide',
        name: 'guide',
        component: () => import('@/views/user/guide'),
        meta: {title: "工具使用指南", keepAlive: true}
      },
    ]
  },

  {
    path: '*',
    redirect: '/home'
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
})
// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     document.title = to.meta.title;
//   } else {
//     next()
//   }
// });
export default router
